'use strict';

module.exports = ['Private', 'Practically Private', 'Semiprivate', 'Main Dining Area'];